import Swiper from 'swiper/dist/js/swiper';
import * as helpers from '../../../js/helpers';

export default function hero() {
    const carousels = new Swiper('.js-swiper-primary', {
        init: false,
        speed: 500,
        loop: false,
        watchOverflow: true,
        effect: 'fade',
        simulateTouch: false,
        autoplay: false,
        a11y: {
            enabled: false,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            bulletElement: 'li',
            clickable: true,
            bulletClass: 'swiper-pagination__bullet',
            bulletActiveClass: '-is-active',
            renderBullet: (index, className) => {
                return `
                            <li class="${className}" role="presentation">
                                <button class="swiper-pagination__bullet-btn" role="tab" aria-selected="false">
                                    <span class="ghost">${index + 1}</span>
                                </button>
                            </li>
                        `;
            },
        },
    });

    const setCarouselWraps = (carouselInstance) => {
        const carouselContainer = carouselInstance.el;

        let carouselWrapper;
        for (let i = 0; i < carouselContainer.children.length; i++) {
            if (helpers.hasClass(carouselContainer.children[i], 'swiper-wrapper')) {
                carouselWrapper = carouselContainer.children[i];
            }
        }

        const carouselSlides = carouselWrapper.children;
        const carouselParentWrapper = carouselContainer.parentNode;
        const carouselArrows = carouselParentWrapper.querySelectorAll('button.-prev, button.-next');

        helpers.addClass(carouselContainer, 'swiper-container');

        for (let i = 0; i < carouselSlides.length; i++) {
            helpers.addClass(carouselSlides[i], 'swiper-slide');
        }

        for (let i = 0; i < carouselArrows.length; i++) {
            helpers.addClass(carouselArrows[i], 'js-swiper-control');
        }
    };

    const setNavigation = (carouselInstance) => {
        const instanceData = carouselInstance.el.dataset;
        let buttonNext;
        let buttonPrev;

        if (instanceData.outsideNavigation === 'true') {
            buttonNext = carouselInstance.el.parentNode.querySelector('button.-next');
            buttonPrev = carouselInstance.el.parentNode.querySelector('button.-prev');
        } else {
            buttonNext = carouselInstance.el.querySelector('button.-next');
            buttonPrev = carouselInstance.el.querySelector('button.-prev');
        }

        carouselInstance.params.navigation.nextEl = buttonNext;
        carouselInstance.params.navigation.prevEl = buttonPrev;
    };

    const setControlsDisplay = (carouselInstance, state) => {
        const controls = carouselInstance.el.parentNode.querySelectorAll('.js-swiper-control');
        for (let i = 0; i < controls.length; i++) {
            const control = state
                ? helpers.addClass(controls[i], '-is-hidden')
                : helpers.removeClass(controls[i], '-is-hidden');
        }
    };

    const setControlsState = (carouselInstance) => {
        const controls = carouselInstance.el.parentNode.querySelectorAll('.js-swiper-control');
        for (let i = 0; i < controls.length; i++) {
            const state = helpers.hasClass(controls[i], 'swiper-button-disabled');
            const control = state
                ? controls[i].setAttribute('disabled', 'disabled')
                : controls[i].removeAttribute('disabled');
        }
    };

    const checkCarouselBeforeInit = (carouselInstance) => {
        const instanceSlides = carouselInstance.el.querySelectorAll('.swiper-slide').length;

        setControlsDisplay(carouselInstance, true);

        if (instanceSlides > carouselInstance.params.slidesPerView) {
            setControlsDisplay(carouselInstance, false);
            carouselInstance.init();
        }
    };

    const setSlidesAccessibility = (carouselInstance, activeIndex) => {
        const slides = carouselInstance.el.querySelectorAll('.swiper-slide');
        let activeSlide = carouselInstance.el.querySelector(`.swiper-slide-active[data-swiper-slide-index="${activeIndex}"]`);

        if (activeSlide === null) {
            activeSlide = carouselInstance.el.querySelector('.swiper-slide-active');
        }

        for (let i = 0; i < slides.length; i++) {
            slides[i].setAttribute('aria-hidden', true);
            helpers.setTabindex(slides[i], -1);
        }

        activeSlide.setAttribute('aria-hidden', false);
        helpers.setTabindex(activeSlide, 0);
    };

    const setBulletsAccessibility = (carouselInstance) => {
        const pagination = carouselInstance.el.querySelector('.swiper-pagination');
        if (pagination) {
            const bullets = pagination.querySelectorAll('.swiper-pagination__bullet .swiper-pagination__bullet-btn');
            const activeBullet = pagination.querySelector('.swiper-pagination__bullet.-is-active .swiper-pagination__bullet-btn');

            for (let j = 0; j < bullets.length; j++) {
                bullets[j].setAttribute('aria-selected', false);
                bullets[j].setAttribute('tabindex', -1);
            }

            activeBullet.setAttribute('aria-selected', true);
            activeBullet.setAttribute('tabindex', 0);
        }
    };

    const addBulletTitle = (bullet, slide) => {
        const bulletBtn = bullet.querySelector('.swiper-pagination__bullet-btn');

        // generateId
        const id = helpers.getUniqId();

        // set slide title
        const title = slide.querySelector('.js-wiper-bullet-text');
        if (title !== null) {
            bulletBtn.querySelector('.ghost').innerHTML = title.innerHTML;
        }

        // set bullet id's
        bulletBtn.id = `label-swiper-content-id-${id}`;
        bulletBtn.setAttribute('aria-controls', `swiper-content-id-${id}`);

        // set slide id's
        slide.id = bulletBtn.getAttribute('aria-controls');
        slide.setAttribute('aria-labelledby', bulletBtn.id);
    };

    const addBulletEvent = (bullet) => {
        bullet.addEventListener('keydown', (event) => {
            const activeElement = event.target.parentNode;
            const firstElement = activeElement.parentNode.firstElementChild;
            const lastElement = activeElement.parentNode.lastElementChild;

            if (!event.ctrlKey && !event.shiftKey && event.keyCode !== 9) {
                if (event.keyCode === 37 || event.keyCode === 38) {
                    if (activeElement === firstElement) {
                        lastElement.click();
                        setTimeout(() => {
                            lastElement.querySelector('button').focus();
                        }, 0);
                    } else {
                        activeElement.previousElementSibling.click();
                        setTimeout(() => {
                            activeElement.previousElementSibling.querySelector('button').focus();
                        }, 0);
                    }
                } else if (event.keyCode === 39 || event.keyCode === 40) {
                    if (activeElement === lastElement) {
                        firstElement.click();
                        setTimeout(() => {
                            firstElement.querySelector('button').focus();
                        }, 0);
                    } else {
                        activeElement.nextElementSibling.click();
                        setTimeout(() => {
                            activeElement.nextElementSibling.querySelector('button').focus();
                        }, 0);
                    }
                } else if (event.keyCode === 36) {
                    firstElement.click();
                    setTimeout(() => {
                        firstElement.querySelector('button').focus();
                    }, 0);
                } else if (event.keyCode === 35) {
                    lastElement.click();
                    setTimeout(() => {
                        lastElement.querySelector('button').focus();
                    }, 0);
                }
                event.preventDefault();
            }
        });
    };

    const rebuildBullets = (carouselInstance) => {
        const slides = carouselInstance.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
        const pagination = carouselInstance.el.querySelector('.swiper-pagination');

        if (pagination) {
            const bullets = pagination.querySelectorAll('.swiper-pagination__bullet');

            for (let i = 0; i < bullets.length; i++) {
                addBulletTitle(bullets[i], slides[i]);
                addBulletEvent(bullets[i]);
            }
        }
    };

    const manageAutoplayState = (carouselInstance, state) => {
        const actionsContainer = carouselInstance.el.querySelector('.swiper-actions');

        if (actionsContainer) {
            const play = actionsContainer.querySelector('.js-swiper-play');
            const pause = actionsContainer.querySelector('.js-swiper-pause');
            const slides = carouselInstance.el.querySelectorAll('.swiper-slide');
            const videoSlide = carouselInstance.el.querySelector('.hero-item video');

            if (slides.length > 1 || videoSlide !== null) {
                // reset state
                play.setAttribute('aria-hidden', true);
                pause.setAttribute('aria-hidden', true);
                helpers.removeClass(pause, '-is-active');
                helpers.removeClass(play, '-is-active');

                if (state) {
                    pause.setAttribute('aria-hidden', false);
                    helpers.addClass(pause, '-is-active');
                    // pause.focus();
                } else {
                    play.setAttribute('aria-hidden', false);
                    helpers.addClass(play, '-is-active');
                    // play.focus();
                }
            } else {
                actionsContainer.style.display = 'none';
            }
        }
    };

    const setControlsPosition = (screenSize, carouselInstance) => {
        const pagination = carouselInstance.querySelector('.swiper-pagination');
        const controls = carouselInstance.querySelectorAll('.js-swiper-control');
        const actions = carouselInstance.querySelector('.swiper-actions');
        const image = carouselInstance.querySelector('.swiper-slide-active img');

        const imageHeight = image.height;
        const offset = imageHeight / 2;

        if (window.innerWidth <= screenSize) {
            for (let i = 0; i < controls.length; i++) {
                controls[i].style.top = `${offset}px`;
            }

            pagination.style.bottom = 'auto';
            actions.style.bottom = 'auto';
            pagination.style.top = `${imageHeight - 17}px`;
            actions.style.top = `${imageHeight - 26}px`;
        } else {
            for (let i = 0; i < controls.length; i++) {
                controls[i].removeAttribute('style');
            }

            pagination.removeAttribute('style');
            actions.removeAttribute('style');
        }
    };

    const setInstanceSettings = (carouselInstance) => {
        const instanceData = carouselInstance.el.dataset;

        for (const data in instanceData) {
            if (data === 'controlsPosition') {
                if (instanceData[data] === 'hero') {
                    setControlsPosition(767, carouselInstance.el);

                    window.addEventListener('resize', () => {
                        setControlsPosition(767, carouselInstance.el);
                    });
                }
            }
        }
    };

    // Init all hero instances
    [].concat(carousels || []).filter(carousel => !!carousel.el).forEach((carousel) => {
        // if we have only one instance
        setNavigation(carousel);
        setCarouselWraps(carousel);
        carousel.on('init', () => {
            setControlsState(carousel);
            setBulletsAccessibility(carousel);
            setSlidesAccessibility(carousel, carousel.realIndex);
            rebuildBullets(carousel);
            setInstanceSettings(carousel);
        });

        checkCarouselBeforeInit(carousel);
        // carousel.init();
    });

    const heroInstances = document.querySelectorAll('.hero');

    for (let i = 0; i < heroInstances.length; i++) {
        const instance = heroInstances[i].swiper;
        const play = instance.el.querySelector('.js-swiper-play');
        const pause = instance.el.querySelector('.js-swiper-pause');
        const video = instance.el.querySelector('.hero-item video');
        let videoAutoplayState = true;

        let autoplayState = instance.autoplay.running;

        instance.on('slideChange', () => {
            setBulletsAccessibility(instance);
            setControlsState(instance);
        });

        instance.on('slideChangeTransitionEnd', () => {
            setSlidesAccessibility(instance, instance.realIndex);

            if (pause) {
                if (!instance.autoplay.running && helpers.hasClass(pause, '-is-active')) {
                    instance.autoplay.start();
                }
            }
        });

        manageAutoplayState(instance, autoplayState);

        if (video !== null) {
            manageAutoplayState(instance, videoAutoplayState);
            video.play();
            video.addEventListener('ended', () => {
                video.play();
            });
        }

        if (play) {
            play.addEventListener('click', () => {
                if (video === null) {
                    instance.autoplay.start();
                    autoplayState = instance.autoplay.running;
                    manageAutoplayState(instance, autoplayState);
                } else {
                    video.play();
                    videoAutoplayState = true;
                    manageAutoplayState(instance, videoAutoplayState);
                }
            });
        }

        if (pause) {
            pause.addEventListener('click', () => {
                if (video === null) {
                    instance.autoplay.stop();
                    autoplayState = instance.autoplay.running;
                    manageAutoplayState(instance, autoplayState);
                } else {
                    video.pause();
                    videoAutoplayState = false;
                    manageAutoplayState(instance, videoAutoplayState);
                }
            });
        }
    }
}
